import { render } from "./ComplementPage.vue?vue&type=template&id=0325889d&scoped=true&ts=true"
import script from "./ComplementPage.vue?vue&type=script&lang=ts"
export * from "./ComplementPage.vue?vue&type=script&lang=ts"

import "./ComplementPage.vue?vue&type=style&index=0&id=0325889d&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0325889d"]])

export default __exports__